<template>
  <el-dialog title="权限管理" :visible.sync="formVisible" :close-on-click-modal="false" width="800px" v-if="formVisible">
    <el-form class="form-custom" ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="100px">
      <el-form-item label="入口权限：" prop="newCityCompanyId">
        <div class="lab" :class="{'active': item.isActive}" v-for="(item,index) in rightsList" :key="index" @click="handleActive(item)">
          <i class="el-icon-success" v-if="item.isActive"></i>{{item.value}}
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="handleAdd">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>

import clientListApi from '@/api/client/clientList'
export default {
  data() {
    return {
      formVisible: false,
      rightsList: [{ key: 1, value: '皮肤检测' }, { key: 2, value: '患者档案' }]
    }
  },
  created() {
  },
  methods: {
    handleUpdate(row) {
      this.formVisible = true
    },
    handleActive(item) {
      item.isActive = !item.isActive
      this.$forceUpdate();
    },
    submitForm() {
      let keys = this.rightsList.filter(item => item.isActive).map(item => item.key)
      if (this.isRepSub) return
      this.isRepSub = true
      clientListApi.updateCityCompany(params).then(res => {
        if (res.code === '0') {
          this.$message.success('操作成功')
          this.submitHint()
        }
      }).catch(res => {
        this.isRepSub = false
      });
    },
  }
}
</script>
<style lang="scss" scoped>
.lab {
  font-size: 14px;
  color: #8f8e8e;
  border-radius: 4px;
  padding: 0 18px;
  display: inline-block;
  border: 1px solid #c5c5c5;
  margin: 5px;
  position: relative;
  cursor: pointer;
  &.active {
    background: #5dbde7;
    color: #fff;
    border-color: #5dbde7;
  }
  i {
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
